import { getSignedUrlByFileId } from '@commenda/utils/files/uploadFile';
import React, { useState } from 'react';

interface FileDownloadProps {
  file: {
    // If we already have a signed URL, set it here.
    signedGetUrl?: string;
    // If we need a new signed URL, set ID and it will be retrieved from the backend.
    id: number | undefined;
    fileName: string;
  };
  children?: React.ReactNode;
  token: string | undefined;
}

const FileDownloader = ({ file, children, token }: FileDownloadProps) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async (e) => {
    e.stopPropagation();
    if (!file) {
      console.error('Attempting to download nonexistent file');
      return;
    }

    setLoading(true);

    if (file.signedGetUrl) {
      window.open(file.signedGetUrl);
    } else {
      const signedUrl = await getSignedUrlByFileId(file.id, token);

      if (signedUrl) {
        window.open(signedUrl);
      }
    }

    setLoading(false);
  };

  return <div onClick={handleDownload}>{children}</div>;
};

export default FileDownloader;
